import $ from 'cash-dom'
import { getHours } from 'date-fns'
import { TZDate } from '@date-fns/tz'
import { addTransitDays, isHoliday } from '../utilities/edd-helpers'
import { getUserZipCode } from '../utilities/user-zip-code'
import { queryNarvarShipping } from '../resources/narvar'

if (Pura?.template?.name === 'product') {
  const hasEstimatedDeliveryWidget =
    $('[data-component="estimated-delivery-date"]').length > 0 || false

  if (hasEstimatedDeliveryWidget) {
    const zoneData: { [key: string]: number } = {
      'Midwest-A': 4.5,
      'Midwest-B': 4.8,
      'Midwest-C': 4.7,
      'Mountain-A': 4.3,
      'Mountain-B': 4.4,
      'Northeast-A': 4.5,
      'Northeast-B': 4.9,
      'Northeast-C': 4.7,
      'Northeast-D': 4.5,
      'Pacific': 4.8,
      'South-A': 4.3,
      'South-B': 4.5,
      'Southeast-A': 4.6,
      'Southeast-B': 3.3,
      'Southeast-C': 3.8,
      'West-A': 5.4,
      'West-B': 5.0,
    }

    const subZoneData: { [key: string]: number } = {
      '006': 5.1,
      '007': 5.3,
      '008': 5.7,
      '009': 5.0,
      '031': 4.2,
      '033': 4.1,
      '034': 4.2,
      '039': 4.2,
      '042': 4.2,
      '050': 4.9,
      '056': 4.9,
      '058': 4.8,
      '069': 4.2,
      '074': 4.6,
      '075': 4.5,
      '076': 4.6,
      '077': 5.3,
      '082': 4.3,
      '083': 4.5,
      '084': 4.1,
      '085': 5.2,
      '087': 5.3,
      '106': 4.4,
      '118': 4.2,
      '120': 4.4,
      '121': 4.3,
      '122': 4.4,
      '123': 4.3,
      '124': 4.3,
      '127': 4.3,
      '128': 4.3,
      '130': 4.3,
      '131': 4.4,
      '132': 4.3,
      '133': 4.3,
      '141': 4.2,
      '149': 4.1,
      '151': 4.9,
      '152': 4.9,
      '155': 4.0,
      '158': 4.1,
      '159': 4.0,
      '161': 4.2,
      '163': 4.2,
      '164': 3.8,
      '165': 3.9,
      '166': 4.0,
      '168': 4.1,
      '172': 3.9,
      '173': 4.1,
      '177': 3.9,
      '178': 4.0,
      '179': 4.1,
      '183': 4.1,
      '187': 4.1,
      '190': 4.9,
      '198': 4.9,
      '199': 4.1,
      '206': 4.3,
      '209': 4.9,
      '215': 4.1,
      '217': 4.2,
      '218': 4.0,
      '226': 4.2,
      '227': 4.2,
      '228': 4.2,
      '229': 4.1,
      '237': 4.2,
      '239': 4.3,
      '242': 3.5,
      '244': 4.2,
      '246': 4.2,
      '254': 4.0,
      '258': 4.2,
      '260': 4.2,
      '261': 4.2,
      '265': 4.0,
      '271': 3.7,
      '274': 3.7,
      '275': 3.8,
      '276': 3.7,
      '277': 3.7,
      '279': 4.2,
      '280': 3.7,
      '281': 3.8,
      '282': 3.7,
      '287': 2.9,
      '288': 2.9,
      '293': 2.6,
      '296': 2.6,
      '297': 3.7,
      '298': 3.0,
      '304': 3.0,
      '307': 3.3,
      '308': 3.2,
      '309': 2.9,
      '310': 2.9,
      '312': 2.9,
      '318': 2.8,
      '319': 2.8,
      '324': 3.2,
      '325': 2.9,
      '330': 4.8,
      '331': 5.0,
      '333': 5.1,
      '334': 5.8,
      '339': 3.4,
      '341': 3.4,
      '349': 4.4,
      '350': 2.8,
      '351': 2.8,
      '352': 2.7,
      '354': 3.1,
      '355': 3.1,
      '356': 3.0,
      '357': 3.0,
      '358': 3.1,
      '359': 3.1,
      '360': 2.6,
      '361': 2.7,
      '362': 3.0,
      '363': 2.9,
      '364': 2.9,
      '365': 2.8,
      '366': 2.8,
      '367': 2.9,
      '368': 2.8,
      '373': 3.2,
      '374': 3.2,
      '376': 3.4,
      '377': 5.7,
      '378': 6.0,
      '379': 6.3,
      '380': 6.2,
      '381': 7.4,
      '384': 4.2,
      '385': 3.3,
      '386': 5.1,
      '387': 4.8,
      '389': 4.7,
      '390': 4.9,
      '391': 4.9,
      '392': 4.9,
      '393': 4.4,
      '394': 3.1,
      '395': 3.0,
      '396': 4.2,
      '397': 4.4,
      '400': 3.8,
      '401': 3.5,
      '402': 5.0,
      '403': 2.8,
      '404': 2.8,
      '405': 2.8,
      '406': 2.9,
      '407': 2.9,
      '409': 3.3,
      '411': 4.2,
      '414': 3.6,
      '415': 4.1,
      '416': 4.1,
      '420': 3.8,
      '421': 3.2,
      '422': 3.2,
      '423': 3.4,
      '424': 3.3,
      '425': 3.0,
      '426': 2.9,
      '427': 3.4,
      '430': 5.0,
      '432': 5.3,
      '433': 4.0,
      '439': 4.0,
      '440': 5.2,
      '441': 5.8,
      '442': 5.6,
      '443': 6.0,
      '444': 4.0,
      '445': 4.0,
      '447': 4.9,
      '450': 5.2,
      '451': 4.9,
      '452': 5.4,
      '454': 5.4,
      '455': 3.7,
      '457': 4.0,
      '458': 4.1,
      '460': 5.4,
      '461': 5.2,
      '462': 5.8,
      '463': 4.0,
      '464': 3.8,
      '465': 4.1,
      '466': 4.0,
      '467': 4.0,
      '468': 4.0,
      '469': 4.1,
      '471': 3.9,
      '472': 3.9,
      '473': 4.1,
      '474': 3.9,
      '475': 3.6,
      '476': 3.2,
      '477': 3.3,
      '478': 4.0,
      '479': 3.9,
      '480': 5.5,
      '481': 5.8,
      '482': 5.7,
      '483': 5.8,
      '484': 5.5,
      '488': 4.8,
      '495': 5.1,
      '500': 4.1,
      '501': 4.2,
      '502': 4.1,
      '503': 4.0,
      '504': 4.1,
      '505': 4.1,
      '506': 4.3,
      '507': 4.1,
      '508': 4.1,
      '510': 4.4,
      '511': 4.5,
      '512': 4.3,
      '513': 4.4,
      '514': 4.2,
      '515': 4.2,
      '520': 4.3,
      '521': 4.2,
      '522': 4.2,
      '523': 4.2,
      '524': 4.2,
      '525': 4.3,
      '526': 4.1,
      '527': 4.2,
      '528': 4.3,
      '531': 5.3,
      '532': 5.8,
      '534': 5.9,
      '537': 5.9,
      '538': 4.1,
      '539': 3.9,
      '540': 5.5,
      '541': 3.9,
      '542': 4.2,
      '543': 4.1,
      '544': 4.3,
      '545': 4.5,
      '549': 3.8,
      '550': 5.9,
      '551': 6.5,
      '553': 5.8,
      '554': 6.4,
      '562': 5.1,
      '570': 4.3,
      '571': 4.2,
      '572': 5.2,
      '575': 5.2,
      '576': 5.5,
      '583': 5.1,
      '586': 5.1,
      '587': 5.3,
      '588': 5.2,
      '590': 5.1,
      '591': 5.1,
      '592': 5.3,
      '593': 5.3,
      '594': 5.4,
      '595': 5.7,
      '596': 5.4,
      '597': 5.2,
      '598': 5.5,
      '599': 5.4,
      '600': 5.2,
      '601': 5.4,
      '602': 5.1,
      '603': 5.2,
      '604': 5.1,
      '605': 5.2,
      '606': 5.3,
      '607': 5.3,
      '608': 5.3,
      '609': 4.1,
      '610': 4.3,
      '611': 4.1,
      '612': 4.2,
      '616': 4.3,
      '617': 4.2,
      '618': 4.1,
      '619': 4.0,
      '620': 5.1,
      '622': 5.1,
      '624': 4.1,
      '629': 4.2,
      '630': 5.3,
      '631': 5.9,
      '633': 5.5,
      '634': 3.9,
      '637': 4.2,
      '638': 4.4,
      '640': 4.1,
      '641': 4.1,
      '645': 4.1,
      '646': 4.2,
      '647': 4.2,
      '650': 5.0,
      '651': 4.2,
      '653': 4.3,
      '658': 4.3,
      '660': 4.1,
      '661': 4.1,
      '662': 4.0,
      '666': 4.2,
      '667': 4.3,
      '669': 5.0,
      '680': 4.0,
      '681': 3.9,
      '683': 4.2,
      '684': 4.2,
      '685': 4.1,
      '686': 4.4,
      '688': 4.3,
      '705': 3.9,
      '706': 3.9,
      '716': 3.5,
      '717': 3.6,
      '719': 3.6,
      '720': 3.3,
      '721': 3.4,
      '722': 3.3,
      '723': 4.9,
      '724': 3.8,
      '725': 3.7,
      '726': 3.8,
      '727': 3.7,
      '728': 3.4,
      '729': 3.8,
      '734': 3.9,
      '735': 3.9,
      '736': 3.9,
      '737': 3.9,
      '738': 3.9,
      '743': 4.0,
      '745': 3.9,
      '746': 3.7,
      '747': 4.0,
      '750': 4.7,
      '752': 5.0,
      '757': 4.0,
      '761': 4.8,
      '762': 4.7,
      '763': 4.0,
      '767': 4.0,
      '770': 4.8,
      '773': 4.7,
      '774': 4.7,
      '775': 4.6,
      '777': 4.0,
      '787': 4.8,
      '788': 4.1,
      '789': 4.1,
      '793': 4.1,
      '794': 4.1,
      '796': 4.1,
      '797': 4.1,
      '799': 4.0,
      '802': 4.0,
      '831': 4.6,
      '832': 4.7,
      '833': 4.6,
      '834': 4.7,
      '835': 4.9,
      '837': 4.6,
      '838': 5.0,
      '856': 5.1,
      '857': 5.1,
      '880': 3.9,
      '890': 6.1,
      '891': 6.1,
      '897': 4.7,
      '900': 6.3,
      '902': 6.2,
      '903': 6.2,
      '904': 6.4,
      '905': 6.4,
      '906': 6.0,
      '907': 5.9,
      '908': 5.8,
      '910': 6.0,
      '911': 6.2,
      '912': 6.4,
      '913': 6.0,
      '914': 6.4,
      '915': 6.1,
      '916': 6.6,
      '917': 6.1,
      '918': 6.1,
      '919': 4.7,
      '920': 4.7,
      '921': 4.8,
      '922': 5.0,
      '924': 6.2,
      '925': 6.2,
      '926': 5.9,
      '927': 6.1,
      '928': 6.1,
      '930': 5.0,
      '931': 4.4,
      '932': 4.6,
      '933': 4.5,
      '934': 4.5,
      '935': 4.5,
      '936': 4.3,
      '937': 4.3,
      '939': 4.8,
      '961': 4.7,
      '963': 8.1,
      '969': 7.6,
      '986': 4.5,
      '988': 5.1,
      '989': 5.1,
      '992': 5.1,
      '996': 5.1,
      '997': 5.2,
      '998': 6.2,
      '999': 5.4,
    }

    const zoneLookup: { [key: string]: string } = {
      '00': 'Northeast-A',
      '01': 'Northeast-A',
      '02': 'Northeast-A',
      '03': 'Northeast-A',
      '04': 'Northeast-A',
      '05': 'Northeast-A',
      '06': 'Northeast-A',
      '07': 'Northeast-B',
      '08': 'Northeast-B',
      '09': 'Northeast-B',
      '10': 'Northeast-C',
      '11': 'Northeast-C',
      '12': 'Northeast-C',
      '13': 'Northeast-C',
      '14': 'Northeast-D',
      '15': 'Northeast-D',
      '16': 'Northeast-D',
      '17': 'Northeast-D',
      '18': 'Northeast-D',
      '19': 'Northeast-D',
      '20': 'Southeast-A',
      '21': 'Southeast-A',
      '22': 'Southeast-A',
      '23': 'Southeast-A',
      '24': 'Southeast-A',
      '25': 'Southeast-A',
      '26': 'Southeast-A',
      '27': 'Southeast-B',
      '28': 'Southeast-B',
      '29': 'Southeast-B',
      '30': 'Southeast-C',
      '31': 'Southeast-C',
      '32': 'Southeast-C',
      '33': 'Southeast-C',
      '34': 'Southeast-C',
      '35': 'Southeast-C',
      '36': 'Southeast-C',
      '37': 'Southeast-C',
      '38': 'Southeast-C',
      '39': 'Southeast-C',
      '40': 'Midwest-A',
      '41': 'Midwest-A',
      '42': 'Midwest-A',
      '43': 'Midwest-A',
      '44': 'Midwest-A',
      '45': 'Midwest-A',
      '46': 'Midwest-A',
      '47': 'Midwest-A',
      '48': 'Midwest-A',
      '49': 'Midwest-A',
      '50': 'Midwest-B',
      '51': 'Midwest-B',
      '52': 'Midwest-B',
      '53': 'Midwest-B',
      '54': 'Midwest-B',
      '55': 'Midwest-B',
      '56': 'Midwest-B',
      '57': 'Midwest-B',
      '58': 'Midwest-B',
      '59': 'Midwest-B',
      '60': 'Midwest-C',
      '61': 'Midwest-C',
      '62': 'Midwest-C',
      '63': 'Midwest-C',
      '64': 'Midwest-C',
      '65': 'Midwest-C',
      '66': 'Midwest-C',
      '67': 'Midwest-C',
      '68': 'Midwest-C',
      '69': 'Midwest-C',
      '70': 'South-A',
      '71': 'South-A',
      '72': 'South-A',
      '73': 'South-A',
      '74': 'South-A',
      '75': 'South-A',
      '76': 'South-A',
      '77': 'South-A',
      '78': 'South-B',
      '79': 'South-B',
      '80': 'Mountain-A',
      '81': 'Mountain-A',
      '82': 'Mountain-A',
      '83': 'Mountain-A',
      '84': 'Mountain-B',
      '85': 'Mountain-B',
      '86': 'Mountain-B',
      '87': 'Mountain-B',
      '88': 'Mountain-B',
      '89': 'Mountain-B',
      '90': 'West-A',
      '91': 'West-A',
      '92': 'West-A',
      '93': 'West-A',
      '94': 'West-B',
      '95': 'West-B',
      '96': 'West-B',
      '97': 'Pacific',
      '98': 'Pacific',
      '99': 'Pacific',
    }

    const getZone = (zip: string) => {
      const firstTwoDigits = zip.substring(0, 2)
      return zoneLookup[firstTwoDigits] || 'Default'
    }

    const shippingDuration = (zipCode: string) => {
      const handling = Number(Pura?.estimatedDelivery?.handling) || 0
      const buffer = Number(Pura?.estimatedDelivery?.buffer) || 0

      const normalizedZip = String(zipCode).padStart(5, '0')
      const prefix = normalizedZip.substring(0, 3)

      if (subZoneData[prefix] !== undefined) {
        return subZoneData[prefix] + handling + buffer
      }

      const zone = getZone(normalizedZip)
      const baseDays = zoneData[zone] || zoneData['West-B']
      return baseDays + handling + buffer
    }

    const getEstimatedShipDate = (zip: string, track: boolean) => {
      const days = shippingDuration(zip)

      const now = new Date()
      const estDate = new TZDate(now, 'America/New_York')
      const estHour = getHours(estDate)

      const cutoffHour = Pura?.estimatedDelivery?.same_day_cut_off || 14

      const roundedDays = Math.round(days)
      let fulfillmentStart = new TZDate(now, 'America/New_York')

      const day = estDate.getDay()
      const isPostFridayCutoff = day === 5 && estHour >= cutoffHour
      const isWeekend = day === 6 || day === 0

      if (isPostFridayCutoff || isWeekend) {
        while (fulfillmentStart.getDay() !== 1) {
          fulfillmentStart.setDate(fulfillmentStart.getDate() + 1)
        }
      } else if (estHour >= cutoffHour) {
        fulfillmentStart.setDate(fulfillmentStart.getDate() + 1)
      }

      while (isHoliday(fulfillmentStart)) {
        fulfillmentStart.setDate(fulfillmentStart.getDate() + 1)
      }

      const targetDate = addTransitDays(fulfillmentStart, roundedDays)

      if (targetDate.getDay() === 0) {
        targetDate.setDate(targetDate.getDate() + 1)
      }

      const options = {
        weekday: 'long' as const,
        month: 'long' as const,
        day: '2-digit' as const,
      }

      const formatted = targetDate.toLocaleDateString('en-US', options)
      $('#estimate').html(
        `<p>Get it by ${formatted} if you choose <b>Standard Shipping</b></p>`
      )

      $('[data-component="estimated-delivery-date"]').removeClass('hidden')
      sessionStorage.setItem('user_zip_code', zip)
      queryNarvarShipping(zip, track)
    }

    $(function () {
      const zipCode = sessionStorage.getItem('user_zip_code')

      if (!zipCode) {
        getUserZipCode()
          .then((zip) => {
            if (zip && /^\d{5}$/.test(zip)) {
              $('#current-zip').text(zip)
              getEstimatedShipDate(zip, false)
            }
          })
          .catch(() => {
            console.warn('Could not get zip from ipapi')
          })
      } else {
        getEstimatedShipDate(zipCode, false)
        $('#current-zip').text(zipCode)
      }

      $('#toggle-zip').on('click', () => {
        $('#zip-form').toggleClass('hidden')
        $('#zip-arrow').text($('#zip-form').hasClass('hidden') ? '▼' : '▲')
      })

      $('#update-zip').on('click', () => {
        const newZip = ($('#zip-input').val() as string).trim()
        if (/^\d{5}$/.test(newZip)) {
          $('#current-zip').text(newZip)
          $('#zip-form').addClass('hidden')
          $('#zip-arrow').text('▼')

          getEstimatedShipDate(newZip, true)
        } else {
          alert('Please enter a valid 5-digit zip code')
        }
      })
    })
  }
}
